// extracted by mini-css-extract-plugin
export default {"search":"SearchFilterGroup_search__BpjFw","sort":"SearchFilterGroup_sort__1W907","wrapper__sort":"SearchFilterGroup_wrapper__sort__TmPmq"};